"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import MuiBox from "@mui/material/Box";
import { useCheckThemeContext } from "../../hooks/useCheckThemeContext";
export const Box = React.forwardRef((props, ref) => {
    useCheckThemeContext("Box");
    return _jsx(MuiBox, Object.assign({}, props, { "data-pixel": "Box", ref: ref }));
});
